// @pf/map-style: the Field Survey style for MapLibre (T-PKG-03).
import palettes from '../dist/palettes.json' with { type: 'json' };
import { fieldSurveyStyle, type MapMode, type Palette } from './style.ts';

export type { MapMode, Palette } from './style.ts';
export { ATTRIBUTION, FONTS, fieldSurveyStyle, GLYPH_RANGES, LOCAL_IDEOGRAPH_FONTS, MODES } from './style.ts';

export const PALETTES = palettes as Record<MapMode, Palette>;

/** The style for a mode, reading tiles from `tiles` and glyphs from the web app's bundle. */
export function styleFor(mode: MapMode, tiles: string, glyphs = '/map/glyphs/{fontstack}/{range}.pbf') {
  return fieldSurveyStyle({ palette: PALETTES[mode], tiles, glyphs });
}
